<template>
  <div class="inicio">
    <!-- <NavbarMain class="main" />
    <SliderComp class="slider" /> -->

    <NavbarMain />
    <SliderComp />

    <div class="container">
      <TimeLine :value="evento" align="alternate" class="customized-timeline">
        <template #marker="slotProps">
          <span
            class="flex w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm padding-icon"
            :style="{ backgroundColor: slotProps.item.color }"
          >
            <!-- <i :class="slotProps.item.icon"></i> -->
             <p>{{ slotProps.item.id }}</p>
          </span>
        </template>
        <template #content="slotProps">
          <CardPrime class="mt-4">
            <template #title>
              {{ slotProps.item.status }}
            </template>
            <template #subtitle>
              {{ slotProps.item.date }}
            </template>
            <template #content>
              <img
                v-if="slotProps.item.image"
                :src="`/images/product/${slotProps.item.image}`"
                :alt="slotProps.item.name"
                width="200"
                class="shadow-sm"
              />
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Inventore sed consequuntur error repudiandae numquam deserunt
                quisquam repellat libero asperiores earum nam nobis, culpa
                ratione quam perferendis esse, cupiditate neque quas!
              </p>
              <ButtonPrime label="Read more" text></ButtonPrime>
            </template>
          </CardPrime>
        </template>
      </TimeLine>
    </div>

    <div class="footer-inicio">
      <FooterComp />
    </div>
  </div>
</template>

<script>

export default {
  name: "ConocenosView",

  data() {
    return {
      showProgressRutas: false,
      origenes: [],
      rutas: [],
      destinos: [],
      rutaorigen: { id: 1, detalle: "SANTA MARTA" },
      rutadestino: null,

      evento: [
                {id: 1,  status: 'Ordered', date: '15/10/2020 10:30', icon: 'pi pi-shopping-cart', color: '#9C27B0', image: 'game-controller.jpg' },
                {id: 2,   status: 'Processing', date: '15/10/2020 14:00', icon: 'pi pi-cog', color: '#673AB7' },
                {id: 3,   status: 'Shipped', date: '15/10/2020 16:15', icon: 'pi pi-shopping-cart', color: '#FF9800' },
                {id: 4,   status: 'Delivered', date: '16/10/2020 10:00', icon: 'pi pi-check', color: '#607D8B' }
            ]
    };
  },

  components: {

  },

  created: function () {
    this.getOrigenes();
    this.consultarDestinos();
  },

  computed: {
    //<!-- :src="require(`@/assets/${publicacion.imagen}`)" -->
  },

  methods: {
    getOrigenes: async function () {
      this.showProgressRutas = true;
      let vue = this;
      await this.axios
        .get("model/rutasdisponibles.php?dato=getciudades")
        .then(function (response) {
          vue.origenes = response.data;
        })
        .catch((error) => {
          this.$utilidad.printConsole(error);
        })
        .then(function () {
          vue.showProgressRutas = false;
        });
    },

    consultarDestinos: async function () {
      this.showProgressRutas = true;
      console.log(this.rutaorigen);
      let vue = this;
      await this.axios
        .get(
          "model/rutasdisponibles.php?dato=getrutasxorigen&ruta_origen=" +
            this.rutaorigen.id
        )
        .then(function (response) {
          vue.rutas = response.data;
        })
        .catch((error) => {
          this.$utilidad.printConsole(error);
        })
        .then(function () {
          vue.showProgressRutas = false;
        });
    },

    consultarOrigenesyDestinos: async function () {
      this.showProgressRutas = true;
      let vue = this;
      await this.axios
        .get(
          "model/rutasdisponibles.php?dato=getrutasxorigenydestino&ruta_origen=" +
            this.rutaorigen.id +
            "&ruta_destino=" +
            this.rutadestino.id
        )
        .then(function (response) {
          vue.rutas = response.data;
        })
        .catch((error) => {
          this.$utilidad.printConsole(error);
        })
        .then(function () {
          vue.showProgressRutas = false;
        });
    },
  },
};
</script>

<style scope>
.padding-icon{
    padding: 0.5rem !important;
}

.main {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.contenedor-rutas {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  width: 90%;
  margin: auto;
}

.cont-ruta {
  height: 18rem;
  border-radius: 10px;
  background-size: cover;
  background-position: center center;

  display: flex;
  flex-direction: column-reverse;
  /* filter: brightness(70%); */
  /* overflow: hidden; */
}

.cont-ruta:hover {
  scale: 1.06;
  opacity: 0.6;
  cursor: pointer;
}

.cont-ruta-opaque {
  height: 5rem;
  /* background-color: rgba(0, 0, 0, 0.7); */
  background-color: rgba(0, 77, 39, 0.5);
}

.cont-ruta-info {
  height: 5rem;
  border-radius: 20px;
  position: absolute;
  display: flex;
  margin-left: 0.5rem;
  gap: 2rem;
}

.info-nombre {
  height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: start;
  /* justify-content: start; */
  /* border: green solid 4px; */
  margin: 0;
}

.card {
  display: flex;
  flex-direction: column;
  box-shadow: 5px 0 10px rgba(0, 0, 0, 0.6);
  border-radius: 10px;
}

.card:hover {
  opacity: 0.6;
  cursor: pointer;
  transition: 1s;
  /* transform: rotateY(20deg); */
}

.component-img {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  flex-grow: 2;
}

.component-detail {
  flex-grow: 1;
  padding: 0.5rem 1rem;
}

.imagen-card {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  border-radius: 10px 10px 0 0;
}

.name-card-float {
  position: absolute;
  bottom: 0;
  left: 1rem;
  color: #fff;
  padding: 0.5rem;
  background-color: rgba(0, 0, 0, 0.6);
  box-shadow: 5px 0 10px rgba(0, 0, 0, 0.6);
  border-radius: 9999px;
}

.info-nombre > .info-tittle {
  /* flex-grow: 3; */
  /* flex: auto; */
  font-family: "Comic Neue", cursive;
  font-weight: bold;
  font-size: 1.5rem;
  color: white;
  margin: 0;

  /* display: flex;
  justify-content: start;
  align-items: end; */
}

.info-nombre > .info-details {
  font-family: "Comic Neue", cursive;
  font-weight: bold;
  font-size: 0.8rem;
  color: white;
  margin: 0;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0; */
}

.info-precio {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
  margin: 0;
}

.info-precio > p {
  font-family: "Comic Neue", cursive;
  font-weight: bold;
  font-size: 1.3rem;
  color: white;
  margin: 0;
}

@media screen and (max-width: 992px) {
  .contenedor-rutas {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 85%;
    margin: auto;
  }
}

@media screen and (max-width: 768px) {
  .contenedor-rutas {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    width: 85%;
    margin: auto;
  }

  .tittle-bln {
    font-size: var(--size-tittle-blnv);
  }
}

.footer-inicio {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
}

.formorigendestino {
  margin-top: 10px;
}

.btn-berlinave {
  background-color: #004d27 !important;
  color: white !important;
}
</style>
